// Listing Type Prices
export const PLUS = 375;
export const PREMIUM = 600;
export const PREMIUM_CAPTURED_PRICE = PREMIUM - PLUS;

// Discount Codes - FLAT
export const UDLEJ100 = 100; // giver 100kr rabat på plus og premium
export const PREMIUM200 = 200; // giver 200kr rabat på premium

// Discount Codes - PERCENTAGE
export const UDLEJ10P = 0.9; // giver 10% rabat på plus og premium
export const PREMIUM20P = 0.8; // giver 20% rabat på premium
